module.exports = __webpack_public_path__ + "img/postepay.6ab215e9.png";